import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import LogProductHelper from '@iso/lib/api/logProductHelper';
import { notification } from '@iso/components';
import actions from './actions';
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* LogProductReadRequest() {
    yield takeEvery(actions.LOG_PRODUCT_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(LogProductHelper.read,payload);
      console.log('---serachResultLOG_PRODUCTAPI--', searchResult )
      if (searchResult.status) {
        yield put(
          actions.LogProductListSuccess(
            searchResult.exportresult,  
            searchResult.result,
            searchResult.status,
            searchResult.totalRecordCount,
            searchResult.passedRows,
            searchResult.failedRows,
            payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.LogProductListSuccess([],  [],0,0,0,0,1)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* LogProductFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.LOG_PRODUCT_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(LogProductHelper.findById,payload.listid);
      if (searchResult.status) {
        yield put(
          actions.LogProductListById(
          searchResult.result,
          searchResult.message
          )
        );
      } else {
      }
    } catch (error) {
    }
  });
}


/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(LogProductReadRequest),
    fork(LogProductFindByIdRequest), 
  ]);
}
